import { pxToRems } from '@awaze/design-system.components.global-style'
import { Heading, Text } from '@awaze/design-system.components.text'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import { FormattedMessage } from 'react-intl'
import { DATE_FORMAT } from 'src/constants'
// import { Button } from '@awaze/design-system.components.button'
// import { Chevron } from 'src/utils/icons/icons'
import {
  BaseGrid,
  BaseGridItem,
} from '@awaze/design-system.components.base-grid'
import { Container } from '@awaze/design-system.components.container'
import { breakpoints } from '@awaze/design-system.utils.react'
import BlogTags from '@/components/BlogTags/BlogTags'
import styled from 'styled-components'
import { BlogTag } from '@/components/BlogTags/mapBlogTag'
import { getAuthorName } from 'src/utils/blog/blog-utils'

type Alignment = 'center' | 'left' | 'right'
export interface BlogHeaderModuleProps {
  title?: string
  description?: string
  alignment: Alignment
  author: string
  timeToRead: number
  blogTags: BlogTag[]
  createdAt: string
  updatedAt: string
}

const HeadLineContainer = styled(Container)`
  padding: ${() => `${pxToRems(48)} 0 ${pxToRems(16)}`};

  @media (min-width: ${breakpoints[1]}px) {
    padding: ${() => `${pxToRems(56)} 0`};
  }

  a.back-button {
    color: ${({ theme }) => theme.ColorButtonGhostSecondaryText};
    text-decoration: none;
  }
`
const HeadLineContent = styled.div<{ alignment: Alignment }>`
  text-align: ${(props) => props.alignment};
  margin-top: ${() => `${pxToRems(32)}`};

  > .blog-info {
    white-space: pre-wrap;
    margin-top: ${pxToRems(16)};

    > span {
      display: block;
      margin-top: ${() => pxToRems(16)};
      @media (min-width: ${breakpoints[0]}px) {
        display: inline-block;
        margin-top: 0;
        &:before {
          content: '|';
          margin: ${() => `0 ${pxToRems(8)}`};
        }
      }
    }
  }
`

export const BlogHeaderModule: React.FC<BlogHeaderModuleProps> = ({
  title,
  description,
  author,
  timeToRead,
  blogTags,
  createdAt,
  updatedAt,
  alignment,
}) => {
  const authorsName = getAuthorName(author)

  updatedAt = updatedAt && format(parseISO(updatedAt), DATE_FORMAT)
  createdAt = createdAt && format(parseISO(createdAt), DATE_FORMAT)

  return (
    <div style={{ padding: '0 16px' }}>
      <HeadLineContainer>
        {/* This button is hidden until editors are ready */}

        {/* {createdAt && (
          <Button
            className="back-button"
            text="Back to Journal"
            colourScheme="reversed"
            icon={<Chevron reverse />}
            href="/blog"
            variant="text"
            as="a"
          />
        )} */}
        <BaseGrid flush>
          <BaseGridItem columns={[12, 8]} offsets={[0, 2]}>
            <HeadLineContent alignment={alignment}>
              {title && <Heading sizes={500}>{title}</Heading>}
              {description && <Text sizes={500}>{description}</Text>}
              {author && (
                <Text sizes={100} className="blog-info">
                  <FormattedMessage
                    id="blogDate.posted"
                    defaultMessage="Posted on {createdAt}"
                    values={{
                      createdAt,
                    }}
                  />
                  {createdAt !== updatedAt && (
                    <FormattedMessage
                      id="blogDate.updated"
                      defaultMessage=", updated on {updatedAt}"
                      values={{
                        updatedAt,
                      }}
                    />
                  )}
                  <span>
                    <FormattedMessage
                      id="blogHeader.info"
                      defaultMessage="by: {authorsName}   |   {timeToRead} minute read"
                      values={{ authorsName, timeToRead }}
                    />
                  </span>
                </Text>
              )}
              {Boolean(blogTags?.length) && <BlogTags tags={blogTags} />}
            </HeadLineContent>
          </BaseGridItem>
        </BaseGrid>
      </HeadLineContainer>
    </div>
  )
}
